<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/ptPlanner')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateEditPlanner('plannerEdit')" data-vv-scope="plannerEdit">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="status_planner" v-validate="'required'" v-model="addPlanner.pt_planner_activity_id" class="form-control">
                    <option value="null">Please select</option>
                    <option v-for="item in plannerActivity" :key="item.id" :value="item.id">{{item.name}}</option>
                    <option value="17">RESCHEDULE</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('plannerEdit.status_planner') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="addPlanner.branch_id" class="form-control">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="ifPlannerMember(addPlanner.pt_planner_activity_id)">
                <b-col sm="2">
                  <label>Member</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember" class="border-bottom" name="member_id" v-model="addPlanner.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="ifPlannerMember(addPlanner.pt_planner_activity_id)">
                <b-col sm="2">
                  <label>Leads</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsLeads" class="border-bottom" name="member_id" v-model="addPlanner.member_id"></model-select>
                  </div>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'editPlanner',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      dataBranch: [],
      listMember: [],
      optionsMember: [],
      optionsLeads: [],
      dataActivity: [],
      plannerActivity: [],
      plannerActivity2: [],
      planner_id: '',
      optionsMember: [
        { value: 0, text: 'Please select' }
      ],
      optionsLeads: [
        { value: 0, text: 'Please select' }
      ],
      addPlanner: {
        branch_id: null,
        personal_trainer_id: '',
        member_id: 0,
        pt_planner_time_id: 0,
        date: '',
        pt_planner_activity_id: null
      },
    }
  },
  methods: {
    ifPlannerMember (event) {
      if (event === 1 || event === 2 || event === 3 || event === 4 || event === 5 || event === 6) {
        return true
      } else {
        return false
      }
    },
    validateEditPlanner (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if(result) {
          // console.log('All Data', this.addPlanner)
          axios.put('crm/v1/pt_planner/' + this.$route.query.planner_id, this.addPlanner).then(response => {
            // console.log('test', response)
            this.$router.push('/ptPlanner' + '?pt_id=' + this.$route.query.pt_id + '&branch_id=' + this.$route.query.branch_id)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      // get Branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
      axios.get('crm/v1/pt_planner/' + this.$route.query.planner_id).then(response => {
        this.addPlanner.member_id = response.data.data.member_id
        this.addPlanner.pt_planner_time_id = response.data.data.pt_planner_time_id
        this.addPlanner.date = response.data.data.date
        this.addPlanner.branch_id = response.data.data.branch_id
        this.addPlanner.pt_planner_activity_id = response.data.data.pt_planner_activity_id
        // console.log('error', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/pt_planner_activity?sorting=id&sorting_type=asc').then(response => {
        this.dataActivity = response.data.data.rows
        var data1 = [...response.data.data.rows]
        // var data2 = [...response.data.data.rows]

        var getLength = data1.length
        data1.splice(getLength - 5, 5)
        this.plannerActivity = data1
        // console.log('test data 1', this.plannerActivity)
        // data2.splice(0, 12)
        // this.plannerActivity2 = data2

        // console.log('test data 2', this.plannerActivity2)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member/data_entry').then(response => {
        this.listMember = response.data.data.rows
        for (var i = 0; i < this.listMember.length; i++) {
          let memberBranchId
          if(!this.listMember[i].branch_id) {
            memberBranchId = '(FT-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          } else {
            memberBranchId = '(' + this.listMember[i].branch.codename + '-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: this.listMember[i].first_name + ' ' + this.listMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: memberBranchId})
          this.optionsMember.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      // List leads
      axios.get('crm/v1/leads/pt-planner-leads').then(response => {
        let listLeads = response.data.data.rows
        for (var i = 0; i < listLeads.length; i++) {
          let memberLeads
          if(listLeads[i].branch_id) {
            memberLeads = '(' + listLeads[i].id + ') ' + listLeads[i].first_name + ' ' + listLeads[i].last_name
          } else {
            memberLeads = '(' + listLeads[i].id + ') ' + listLeads[i].first_name + ' ' + listLeads[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.listMember[i].id, text: this.listMember[i].first_name + ' ' + this.listMember[i].last_name})
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: listLeads[i].id, text: memberLeads})
          this.optionsLeads.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    // this.addPlanner.pt_planner_time_id = this.$route.query.planner_time
    // this.addPlanner.date = this.$route.query.date
    this.addPlanner.personal_trainer_id = Auth.Session.get().paradigm_id
    this.addPlanner.personal_trainer_id = this.$route.query.pt_id
    this.fetchData()
  }
}
</script>

<style>
</style>
